import { computed, onBeforeUnmount, watch, Ref, nextTick } from "vue";
import { debounce } from "lodash-es";
import type { DynamicTableProps } from "../dynamic-table";
import type { TableMethods } from "@/components/lt-a-table/src";
import type { TableState } from './useTableState';

type UseScrollParams = {
  props: DynamicTableProps;
  tableID: string;
  tableData: Ref<any[]>;
  tableMethods: TableMethods;
  tableState: TableState,
  ifCaleScrollY: Ref<Boolean>
};

export type UseScrollType = ReturnType<typeof useScroll>;

// 获取元素到顶部距离-通用方法
export const getPositionTop = (node: HTMLElement) => {
  let top = node.offsetTop;
  let parent = node.offsetParent as HTMLElement;
  while (parent != null) {
    top += parent.offsetTop;
    parent = parent.offsetParent as HTMLElement;
  }
  return top; // 所有的父元素top和
};

export const useScroll = ({
  props,
  tableID,
  tableData,
  tableMethods,
  tableState,
  ifCaleScrollY
}: UseScrollParams) => {
  // const currIns = getCurrentInstance();
  const { initColumnFilter, setContentHeight } = tableMethods;
  // const { paginationRef } = tableState
  // const scrollY = ref<number>();
  const scroll = computed(() => {
    return {
      y: '100%',
      x: "100%", //使滚动条为所有列之和
      ...props.scroll,
    };
  });

  const getScrollY = debounce(() => {
    //自动计算表格滚动高度
    // if (!props.autoHeight) return;
    // const targetTable = $("#" + tableID);
    // if (targetTable.length == 0) {
    //   return
    // }
    // const el =
    //   targetTable.find(".ant-table-body").get(0) ||
    //   targetTable.find(".ant-table-tbody").get(0); //表格主体
    // const _pagination = unref(paginationRef);

    // //@ts-ignore
    // if (_pagination.total > 0 && (_pagination.total >= _pagination.pageSize)) {
    //   //如果当前数据大于一页，则需要按照标准程序生成高度
    //   if (el) {
    //     const y =
    //       document.documentElement.offsetHeight -
    //       getPositionTop(el as HTMLDivElement);
    //     // 简单粗糙的实现
    //     if (props.pagination == false) {
    //       scrollY.value = y - 52 + 24 + 19;
    //     } else if (typeof props.pagination == "undefined") {
    //       //@ts-ignore
    //       scrollY.value = y - 52;
    //     } else if (props.pagination.hideOnSinglePage == true) {
    //       if (isObject(_pagination)) {
    //         //@ts-ignore
    //         if (_pagination.total <= _pagination.pageSize) {
    //           scrollY.value = y - 52 + 24 + 19;
    //         } else {
    //           scrollY.value = y - 52;
    //         }
    //       }
    //     } else {
    //       scrollY.value = y - 52;
    //     }
    //   }
    //   ifCaleScrollY.value = false
    // } else {
    //   const height = targetTable[0].clientHeight //表格的高度
    //   if (el) {
    //     const bodyHeight =
    //       document.documentElement.offsetHeight -
    //       getPositionTop(el as HTMLDivElement);
    //     if (props.columnFilter.length > 0) {
    //       el.style.height = height - 52 + 24 + 'px!important'
    //       el.style.maxHeight = height - 52 + 24 + 'px!important'
    //       scrollY.value = bodyHeight - 52 + 24
    //     } else {
    //       el.style.height = height - 52 + 24 + 'px!important'
    //       el.style.maxHeight = height - 52 + 24 + 'px!important'
    //       scrollY.value = bodyHeight - 52 + 24
    //     }
    //   }
    //   // if (body.length > 0) {
    //   //   setBodyHeight(body[0], height)
    //   // }
    //   // if (tdbody.length > 0) {
    //   //   setBodyHeight(tdbody[0], height)
    //   // }

    //   //ifCaleScrollY.value = false
    // }

    nextTick(() => {
      initColumnFilter(tableID, props);
      setContentHeight()
    });
  });

  window.addEventListener("resize", getScrollY);
  watch(() => tableData.value, getScrollY)
  watch(() => ifCaleScrollY.value, getScrollY)

  onBeforeUnmount(() => {
    window.removeEventListener("resize", getScrollY);
  });

  return {
    scroll,
  };
};
